import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, useTheme } from '@mui/material';
import { css } from '@emotion/css';
import { UserState } from '@features/Auth/user.slice';
import { RootState } from '@redux/store';
import { useSelector } from 'react-redux';
import { IMainNavLinkItems } from '../constants/pages';

export interface MainMenuProps {
  links: IMainNavLinkItems[];
}

const MainMenu: React.FC<MainMenuProps> = ({ links }) => {
  const ref = useRef(null);
  const [mainLinks, setMainLinks] = useState(links);
  const userState: UserState = useSelector((state: RootState) => state.user);

  const activeLocation = useLocation();
  const theme = useTheme();
  const isActive = (path: string) => activeLocation.pathname.startsWith(path);

  const styles = {
    linkItem: css`
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.2rem 1rem 0 1rem;
      font-size: 14px;
      font-weight: 600;
      color: ${theme.palette.secondary.main} !important;
      text-decoration: none;
      text-transform: uppercase;
      transition: 0.2s ease-in-out;

      &:hover {
        background-color: ${theme.palette.accent.main};
      }
    `,
    activeLink: css`
      background-color: ${theme.palette.accent.main};
    `,
    container: {
      display: 'flex',
      height: '100%',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  };

  useEffect(() => {
    setMainLinks(links);
  }, [links]);

  return (
    <>
      <Box id="main-menu" ref={ref} sx={styles.container}>
        {userState?.user?.signedIn ? (
          <>
            {mainLinks.map((item) =>
              !item.roleRequired ||
              userState?.user?.roles?.includes(item?.roleRequired) ? (
                <Link
                  key={item.name}
                  to={item.location}
                  onClick={() => window.scrollTo(0, 0)}
                  className={`${styles.linkItem} ${isActive(item.location) && styles.activeLink}`}
                >
                  <span>{item.name}</span>
                </Link>
              ) : null
            )}
          </>
        ) : null}
      </Box>
    </>
  );
};

export default MainMenu;
